<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f1bMnJ/tc-custom/9781467426589.jpg?1742010338690" alt="This image is the cover for the book New Testament Survey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Testament Survey
      </h1>
      <p class="bookDescription body article font2">
        <p>First published in 1953 and revised in 1961, Merrill Tenney's comprehensive survey has served to introduce the general reader, student, and teacher to the world and message of the New Testament.<br/><br/> Written in a clear, nontechnical style, <i>New Testament Survey</i> begins with a survey of the social, political, economic, and religious background of the New Testament, and then goes on to examine the various groups of New Testament books, which are considered in their historical settings. The book concludes with a penetrating study of the New Testament canon.<br/><br/> Undertaken at the request of Dr. Tenney, and prepared with his full approval, this 1985 revision by Walter M. Dunnett includes an entirely new chapter on the Jewish background of the New Testament, plus several new short sections, including materials on the Gospels and the canon of the New Testament. The bibliography has been enlarged and updated, and many of the book's numerous illustrations, maps, and charts are new. Great care has been exercised to retain the spirit and quality of the original work, ensuring that the book will remain a standard in the years to come.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Merrill C. Tenney
      </h2>
      
      <p class="authorDescription body article">(d.1985) He was for many years Dean of the Graduate School and Professor of Bible and Theology at Wheaton College in Illinois.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19935f81